import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const fetchDashboardStats = createAsyncThunk("dashboard/stats", async () => {
  const response = await api.get("/dashboard/stats");
  return response.data;
});

export const fetchPipeline = createAsyncThunk("dashboard/pipeline", async () => {
  const response = await api.get("/dashboard/pipeline");
  return response.data;
});

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    stats: null,
    recentActivity: [],
    popularCruiseLines: [],
    pipeline: null,
    status: "idle",
    pipelineStatus: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => { state.status = "loading"; })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.stats = action.payload.stats;
        state.recentActivity = action.payload.recentActivity;
        state.popularCruiseLines = action.payload.popularCruiseLines;
      })
      .addCase(fetchPipeline.pending, (state) => { state.pipelineStatus = "loading"; })
      .addCase(fetchPipeline.fulfilled, (state, action) => {
        state.pipelineStatus = "succeeded";
        state.pipeline = action.payload;
      });
  },
});

export default dashboardSlice.reducer;
